export default __webpack_public_path__ + "static/media/LinkedInIcon.fc798767.svg";